<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm" id="rpref"><a class="xref" href="#/chihineline0007#pref">Preface</a></p>
<p class="tocpt" id="rpt01"><a class="xref" href="#/chihineline0008#pt01"><span class="sm">PART</span> <span class="sm">ONE</span></a></p>
<p class="toc" id="rprog"><a class="xref" href="#/chihineline0009#prog">Prologue</a></p>
<p class="toc" id="rch01"><a class="xref" href="#/chihineline0010#ch01">1  Intimate and Momentous</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/chihineline0011#ch02">2  Seasons and Circulations</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/chihineline0012#ch03">3  Lilacs and Passing Time</a></p>
<p class="toc" id="rch04"><a class="xref" href="#/chihineline0013#ch04">4  Noting with a Climate Eye</a></p>
<p class="toc" id="rch05"><a class="xref" href="#/chihineline0014#ch05">5  Bedrock and Baselines</a></p>
<p class="tocpt" id="rpt02"><a class="xref" href="#/chihineline0015#pt02"><span class="sm">PART</span> <span class="sm">TWO</span></a></p>
<p class="toc" id="rch06"><a class="xref" href="#/chihineline0016#ch06">6  The Green World</a></p>
<p class="toc" id="rch07"><a class="xref" href="#/chihineline0017#ch07">7  Wriggles, Buzzes, and Calls</a></p>
<p class="toc" id="rch08"><a class="xref" href="#/chihineline0018#ch08">8  Feathers and Phenophases</a></p>
<p class="toc" id="rch09"><a class="xref" href="#/chihineline0019#ch09">9  Warm Blood and Live Birth</a></p>
<p class="toc" id="rch10"><a class="xref" href="#/chihineline0020#ch10">10  The Atmosphere at Home</a></p>
<p class="tocpt" id="rpt03"><a class="xref" href="#/chihineline0021#pt03"><span class="sm">PART</span> <span class="sm">THREE</span></a></p>
<p class="toc" id="rch11"><a class="xref" href="#/chihineline0022#ch11">11  Ground Truth</a></p>
<p class="tocbmf" id="racknow"><a class="xref" href="#/chihineline0023#acknow">Acknowledgments</a></p>
<p class="tocbm" id="rread"><a class="xref" href="#/chihineline0024#read">Further Reading</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/chihineline0025#index">Index</a></p>
<p class="tocbm" id="rfn_notes"><a class="xref" href="#/chihineline0026#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hineline-0006.vue?b8ad7388